// @flow
import decodeJwt from 'jwt-decode';
import type { AuthTokenData } from 'reducers/auth';

const TOKEN_STORAGE_KEY = 'token';
const FEATURES_STORAGE_KEY = 'features';

export const FEATURE_STYLE_MAPPING = {
  'temporary': 'temporal_airspaces',
  'inventory': 'submitted_applications',
  'restricted': 'restricted_airspaces',
  'tra': 'temporarily_restricted_airspaces',
  'prohibited': 'forbidden_airspaces',
  'dji-flyzone': 'dji_geo_zones',
  'nodronezone': 'no_drone_zones',
  'controlled': 'controlled_airspaces',
  'tiz': 'traffic_information_zones',
  'misc': 'other_airspaces'
}

export function getRawAuthToken(): ?string {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
}

export function decodeAuthToken(): ?AuthTokenData {
  const token = getRawAuthToken();

  if (!token) {
    return null;
  }

  try {
    return decodeJwt(token);
  } catch (e) {
    // Return null for invalid tokens
    return null;
  }
}

export function isFeatureDisabled(feature): ?boolean {
  const features_storage = localStorage.getItem(FEATURES_STORAGE_KEY);
  const features = features_storage === null ? {} : JSON.parse(features_storage);

  if (feature === 'disabled') {
    return true;
  }

  if (feature === 'enabled') {
    return false;
  }

  if (feature in features) {
    return !features[feature];
  }

  return true;
}



// WEBPACK FOOTER //
// ./utils/auth.js